/* eslint no-underscore-dangle: 0 */

import BaseBehavior from '../../../framework/base/base';
import { openPopup } from '../../../shared/utilities/openPopup';

export default class ShareComponent extends BaseBehavior {
	constructor(element) {
		super(element);
		this.addEventListeners();
	}

	trackPlatformUsage(name, url) {
		if (window._satellite && window.digitalData) {
			window.digitalData.share = { name, url };
			window._satellite.track('shareArticle');
		}
		if (window.adobeDataLayer) {
			window.adobeDataLayer.push({
				event: 'shareContent',
				shareInfo: {
					shareNetwork: name,
					shareUrl: url
				}
			});
		}
	}

	openUrlInPlatform(target, platform) {
		let { api } = this.element.dataset;
		// Below condition added to stop picking default current url else current page url will be called in fetch and user will get webpage in response.
		api = api === '' ? 'wrongurl' : api;
		// eslint-disable-next-line
		const originalUrl = location.href;
		// eslint-disable-next-line
		return fetch(`${api}?longUrl=${originalUrl}`)
			.then(
				response => {
					if (!response.ok) {
						return Promise.resolve(originalUrl);
					}
					return response.text();
				},
				// In case of wrong api, to handle it and to stop error. Condition will be handled in !response.ok part
				() => {
					return originalUrl;
				}
			)
			.then(data => {
				// case for providing fallback url in case  null or blank is returned as shorturl.
				// url from api is wrapped in "", causing error, so we need to remove those.
				const url = data === (null || undefined || '') ? originalUrl : data.replaceAll('"', '');
				let updatedUrl;

				if (platform === 'email') {
					// we have taken in dataset as well for handling email case, since href encoded string by default.
					updatedUrl = target.dataset.emailHref.replace('<url>', url);
					const parts = updatedUrl.split('mailto:?subject=')[1].split('&body=');
					updatedUrl = `mailto:?subject=${encodeURIComponent(parts[0])}&body=${encodeURIComponent(
						parts[1]
					)}`;
					// eslint-disable-next-line
					location.replace(updatedUrl);
				} else if (platform === 'wechat') {
					const attribute = target.dataset.type;
					this.publish('/lightbox/open', {
						target: url,
						type: attribute || 'id'
					});
				} else if (platform !== 'email' && platform !== 'wechat') {
					updatedUrl = decodeURI(target.href).replace('<url>', url);
					openPopup(updatedUrl);
				}
				this.trackPlatformUsage(platform, originalUrl);
			})
			.catch(err => console.error(err));
	}

	addEventListeners() {
		this.addEventListener(this.element, 'click', e => {
			e.preventDefault();
			const target =
				e.target.tagName === 'A' ? e.target : e.target.closest('.share-component__item');
			const platform = target?.dataset.platform;
			this.openUrlInPlatform(target, platform);
		});
	}
}
